export const getPedidos = 'pedidos'
export const reportePedidos = 'reporte-pedidos'
export const clientePedidos = 'cliente-pedidos'
export const reportePedidosClientes = 'reporte-pedidos-ejercito'
